export async function generatePkceValues () {
  const verifier = btoa(
    String.fromCharCode(...crypto.getRandomValues(new Uint8Array(64)))
  )
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(verifier)
  )
  const challenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
  return { verifier, challenge }
}

export function generateState () {
  const state = btoa(
    String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))
  )
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
  return state
}

export function generateAuthURL (
  baseUrl,
  client_id,
  redirect_uri,
  state,
  challenge
) {
  const redirect = new URL(redirect_uri)
  const params = new URLSearchParams({
    client_id,
    response_type: 'code',
    scope: 'openid email profile creds/read creds/write',
    redirect_uri: redirect,
    state,
    code_challenge_method: 'S256',
    code_challenge: challenge
  })

  const authorizationUrl = `${baseUrl}/oauth2/authorize?${params.toString()}`
  return authorizationUrl
}

export function generateTokenExchange (client_id, code, redirectUri, verifier) {
  const redirect = new URL(redirectUri)
  const params = new URLSearchParams({
    grant_type: 'authorization_code',
    client_id,
    code,
    redirect_uri: redirect,
    code_verifier: verifier
  })
  return params.toString()
}

export function getTokenExpiry () {
  const expiresAt = sessionsStorage.getItem('expires_at')
  return expiresAt ? parseInt(expiresAt, 10) : null
}

export function isTokenExpired () {
  const expiry = getTokenExpiry()
  return !expiry || Date.now() >= expiry
}

export function setTokenExpiry (expiresIn) {
  const expiresAt = Date.now() + expiresIn * 100
  sessionStorage.setItem('expires_at', expiresAt.toString())
}

export function getValidAccesToken () {
  const token = sessionStorage.getItem('accessToken')
  if (!token || isTokenExpired()) return null
  return token
}
